var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "form-item__field",
      class: [_vm.classes, { "form-item__field--full": _vm.fullWidth }],
    },
    [
      _c(
        "div",
        { staticClass: "input-group input-group-booking-detail input-height" },
        [
          _c(
            "label",
            {
              staticClass: "input-label input-group-addon",
              class: _vm.highlight ? "input-highlight" : null,
            },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          !_vm.editable
            ? _c(
                "div",
                { staticClass: "form-control input-height input-container" },
                [
                  _vm.fieldType === "date"
                    ? _c("p", [
                        _vm.showBookingTz
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("date")(
                                        _vm.localFieldBookingTzDate,
                                        _vm.$user.date_format_preference
                                      )
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("date")(
                                        _vm.localField,
                                        _vm.$user.date_format_preference
                                      )
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]),
                        _vm._v(" "),
                        _vm.booking.timezone !== _vm.$user.timezone &&
                        !_vm.tzDateMatch &&
                        _vm.showTz &&
                        _vm.localField
                          ? _c("span", [
                              _vm._v(
                                "\n          (" +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("date")(
                                        _vm.localFieldTzDate,
                                        _vm.$user.date_format_preference
                                      )
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.$user.timezone) +
                                  ")\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n        " + _vm._s(_vm.postText) + "\n      "
                        ),
                      ])
                    : _vm.fieldType === "time"
                    ? _c("p", [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm._f("nullable")(_vm._f("time")(_vm.localField))
                            ) +
                            "\n        "
                        ),
                        _vm.booking.timezone !== _vm.$user.timezone &&
                        _vm.showTz &&
                        _vm.localField
                          ? _c("span", [
                              _vm._v(
                                "\n          (" +
                                  _vm._s(_vm._f("time")(_vm.localFieldTzTime)) +
                                  " " +
                                  _vm._s(_vm.$user.timezone) +
                                  ")\n        "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm.fieldType !== "multi-select" && _vm.currency
                    ? _c(
                        "p",
                        {
                          class: _vm.highlight ? "highlight-text" : null,
                          staticStyle: { width: "100%" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.preText) +
                              _vm._s(
                                _vm._f("currency")(
                                  _vm._f("nullable")(
                                    _vm.value ? _vm.value : _vm.localField
                                  ),
                                  _vm.booking.currency
                                )
                              ) +
                              _vm._s(_vm.postText)
                          ),
                        ]
                      )
                    : _vm.fieldType !== "multi-select"
                    ? _c(
                        "p",
                        {
                          class: _vm.highlight ? "highlight-text" : null,
                          staticStyle: { width: "100%" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.preText) +
                              _vm._s(
                                _vm._f("nullable")(
                                  _vm.value ? _vm.value : _vm.localField
                                )
                              ) +
                              _vm._s(_vm.postText)
                          ),
                        ]
                      )
                    : _vm.fieldType === "multi-select"
                    ? _c(
                        "div",
                        {
                          staticStyle: { display: "flex", "flex-wrap": "wrap" },
                        },
                        _vm._l(_vm.localField, function (item) {
                          return _c(
                            "span",
                            {
                              key: item.id,
                              staticClass: "tag",
                              staticStyle: {
                                margin: "2px 5px",
                                "text-transform": "capitalize",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    item.database_name
                                      ? item.database_name
                                      : item.name
                                  )
                              ),
                              item.other_text
                                ? _c("span", [
                                    _vm._v(
                                      " (" +
                                        _vm._s(
                                          _vm._f("nullable")(
                                            _vm._f("humanize")(item.type)
                                          )
                                        ) +
                                        ") - " +
                                        _vm._s(
                                          _vm._f("nullable")(item.other_text)
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "form-control input-height input-container",
                  style:
                    _vm.fieldType === "textarea"
                      ? "flex-direction: column; justify-content: center;"
                      : null,
                },
                [
                  !_vm.editing && _vm.fieldType === "date"
                    ? _c("p", [
                        _vm.showBookingTz
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("date")(
                                        _vm.localFieldBookingTzDate,
                                        _vm.$user.date_format_preference
                                      )
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("date")(
                                        _vm.localField,
                                        _vm.$user.date_format_preference
                                      )
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]),
                        _vm._v(" "),
                        _vm.booking.timezone !== _vm.$user.timezone &&
                        !_vm.tzDateMatch &&
                        _vm.showTz &&
                        _vm.localField
                          ? _c("span", [
                              _vm._v(
                                "\n          (" +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("date")(
                                        _vm.localFieldTzDate,
                                        _vm.$user.date_format_preference
                                      )
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.$user.timezone) +
                                  ")\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n        " + _vm._s(_vm.postText) + "\n      "
                        ),
                      ])
                    : !_vm.editing && _vm.fieldType === "time"
                    ? _c("p", [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm._f("nullable")(_vm._f("time")(_vm.localField))
                            ) +
                            "\n        "
                        ),
                        _vm.booking.timezone !== _vm.$user.timezone &&
                        _vm.showTz &&
                        _vm.localField &&
                        _vm.$vlastMode &&
                        _vm.booking.address !== "" &&
                        _vm.booking.appearance_type !== "online"
                          ? _c("span", [
                              _vm._v(
                                "\n          (" +
                                  _vm._s(_vm._f("time")(_vm.localFieldTzTime)) +
                                  " " +
                                  _vm._s(_vm.$user.timezone) +
                                  ")\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.booking.timezone !== _vm.$user.timezone &&
                        _vm.showTz &&
                        _vm.localField &&
                        !_vm.$vlastMode
                          ? _c("span", [
                              _vm._v(
                                "\n          (" +
                                  _vm._s(_vm._f("time")(_vm.localFieldTzTime)) +
                                  " " +
                                  _vm._s(_vm.$user.timezone) +
                                  ")\n        "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : !_vm.editing &&
                      _vm.fieldType === "select" &&
                      _vm.otherSelected
                    ? _c("p", [
                        _vm._v(
                          _vm._s(_vm.localField) +
                            " - " +
                            _vm._s(_vm.localOtherField)
                        ),
                      ])
                    : !_vm.editing && _vm.fieldType === "textarea" && _vm.html
                    ? _c("div", {
                        staticClass: "pre-line",
                        domProps: { innerHTML: _vm._s(_vm.localField) },
                      })
                    : !_vm.editing && _vm.fieldType === "textarea"
                    ? _c("div", { staticClass: "pre-line" }, [
                        _vm._v(_vm._s(_vm.localField)),
                      ])
                    : !_vm.editing && _vm.fieldType === "file"
                    ? _c("div", [
                        _c(
                          "a",
                          {
                            attrs: {
                              download: "true",
                              target: "_blank",
                              href: _vm.options.fileUrl,
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("nullable")(
                                  _vm.value ? _vm.value : _vm.localField
                                )
                              )
                            ),
                          ]
                        ),
                      ])
                    : !_vm.editing && _vm.fieldType === "link"
                    ? _c("div", [
                        _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href: _vm._f("nullable")(
                                _vm.value ? _vm.value : _vm.localField
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("nullable")(
                                  _vm.value ? _vm.value : _vm.localField
                                )
                              )
                            ),
                          ]
                        ),
                      ])
                    : !_vm.editing && _vm.fieldType !== "multi-select"
                    ? _c(
                        "p",
                        {
                          class: _vm.highlight ? "highlight-text" : null,
                          staticStyle: { width: "100%" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.preText) +
                              _vm._s(
                                _vm._f("nullable")(
                                  _vm.value ? _vm.value : _vm.localField
                                )
                              ) +
                              _vm._s(_vm.postText)
                          ),
                        ]
                      )
                    : !_vm.editing && _vm.fieldType === "multi-select"
                    ? _c(
                        "div",
                        {
                          staticStyle: { display: "flex", "flex-wrap": "wrap" },
                        },
                        _vm._l(_vm.localField, function (item) {
                          return _c(
                            "span",
                            {
                              key: item.id,
                              staticClass: "tag",
                              staticStyle: {
                                margin: "2px 5px",
                                "text-transform": "capitalize",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    item.database_name
                                      ? item.database_name
                                      : item.name
                                  )
                              ),
                              item.other_text
                                ? _c("span", [
                                    _vm._v(
                                      " (" +
                                        _vm._s(
                                          _vm._f("nullable")(
                                            _vm._f("humanize")(item.type)
                                          )
                                        ) +
                                        ") - " +
                                        _vm._s(
                                          _vm._f("nullable")(item.other_text)
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm.fieldType === "textarea"
                    ? _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.localField,
                            expression: "localField",
                          },
                        ],
                        staticClass: "form-control",
                        staticStyle: { width: "100%" },
                        attrs: {
                          name: _vm.field,
                          type: _vm.fieldType,
                          rows: _vm.rows,
                        },
                        domProps: { value: _vm.localField },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.localField = $event.target.value
                          },
                        },
                      })
                    : _vm.fieldType === "select"
                    ? _c("selectize", {
                        staticClass: "selectize selectize-single",
                        staticStyle: { width: "100%" },
                        attrs: {
                          name: _vm.field,
                          "disable-delete": true,
                          options: _vm.options,
                        },
                        model: {
                          value: _vm.localField,
                          callback: function ($$v) {
                            _vm.localField = $$v
                          },
                          expression: "localField",
                        },
                      })
                    : _vm.fieldType === "date"
                    ? _c("flat-pickr", {
                        staticClass: "form-control",
                        attrs: {
                          config: _vm.dateConfig,
                          placeholder: "DD/MM/YYYY",
                          name: _vm.field,
                        },
                        model: {
                          value: _vm.localField,
                          callback: function ($$v) {
                            _vm.localField = $$v
                          },
                          expression: "localField",
                        },
                      })
                    : _vm.fieldType === "time"
                    ? _c("flat-pickr", {
                        staticClass: "form-control",
                        attrs: {
                          config: _vm.timeConfig,
                          placeholder: "DD/MM/YYYY",
                          name: _vm.field,
                        },
                        model: {
                          value: _vm.localField,
                          callback: function ($$v) {
                            _vm.localField = $$v
                          },
                          expression: "localField",
                        },
                      })
                    : _vm.fieldType === "multi-select"
                    ? _c("booking-field-opportunity-types", {
                        attrs: {
                          type: _vm.field,
                          types: _vm.multiSelectTypes,
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                        },
                        model: {
                          value: _vm.localField,
                          callback: function ($$v) {
                            _vm.localField = $$v
                          },
                          expression: "localField",
                        },
                      })
                    : _vm.fieldType === "location"
                    ? _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c("gmap-autocomplete", {
                            staticClass: "form-control",
                            attrs: {
                              name: "location",
                              placeholder:
                                "1 Brunton Avenue, Richmond, Victoria",
                              value: _vm.booking.address,
                              options: {
                                selectFirstOnEnter: true,
                                strictBounds: true,
                                bounds: {
                                  north: -9.187026,
                                  south: -54.833766,
                                  east: 159.287222,
                                  west: 110.951034,
                                },
                              },
                            },
                            on: {
                              place_changed: _vm.handleAddressChangeCallback,
                            },
                            nativeOn: {
                              input: function ($event) {
                                return _vm.handleResetAddressCallback.apply(
                                  null,
                                  arguments
                                )
                              },
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                $event.preventDefault()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "street_address" },
                            domProps: { value: _vm.stateStreetAddress },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "suburb" },
                            domProps: { value: _vm.stateSuburb },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "state" },
                            domProps: { value: _vm.stateState },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "country" },
                            domProps: { value: _vm.stateCountry },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "postcode" },
                            domProps: { value: _vm.statePostcode },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "area" },
                            domProps: { value: _vm.stateArea },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "latitude" },
                            domProps: { value: _vm.stateLatitude },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "longitude" },
                            domProps: { value: _vm.stateLongitude },
                          }),
                        ],
                        1
                      )
                    : _vm.fieldType === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.localField,
                            expression: "localField",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: _vm.field, type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.localField)
                            ? _vm._i(_vm.localField, null) > -1
                            : _vm.localField,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.localField,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.localField = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.localField = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.localField = $$c
                            }
                          },
                        },
                      })
                    : _vm.fieldType === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.localField,
                            expression: "localField",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: _vm.field, type: "radio" },
                        domProps: { checked: _vm._q(_vm.localField, null) },
                        on: {
                          change: function ($event) {
                            _vm.localField = null
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.localField,
                            expression: "localField",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: _vm.field, type: _vm.fieldType },
                        domProps: { value: _vm.localField },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.localField = $event.target.value
                          },
                        },
                      }),
                  _vm._v(" "),
                  _vm._t("after-info"),
                ],
                2
              ),
          _vm._v(" "),
          _vm.editing &&
          _vm.fieldType === "select" &&
          _vm.otherSelected &&
          _vm.otherField
            ? _c("div", { staticClass: "form-control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localOtherField,
                      expression: "localOtherField",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: _vm.otherField,
                    type: "text",
                    placeholder: "Other Details...",
                  },
                  domProps: { value: _vm.localOtherField },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.localOtherField = $event.target.value
                    },
                  },
                }),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }